import { createFeatureSelector } from '@ngrx/store';
import { LoginPrefillState } from '../reducers/login-prefill.reducer';

export const selectLoginPrefill = createFeatureSelector<LoginPrefillState>('loginPrefill');
